import { LabelWithButton } from '#molecules';
import { useScheduleManage } from '#providers/SchedulesManage';
import useScheduleMembership from './useScheduleMembership';

interface MembershipProps {
  onClick: () => void;
}

const Membership = ({ onClick }: MembershipProps) => {
  const { selectedLecture } = useScheduleManage();

  const { membership } = useScheduleMembership();

  return (
    <LabelWithButton
      label="수강권"
      disabled={!selectedLecture.personId}
      defaultButtonText={
        membership?.lectureName ? membership?.lectureName : '수강권 선택'
      }
      onClick={onClick}
    />
  );
};

export default Membership;
